import * as React from "react";
import { CurrencySymbolDictionary } from "../../../../../../../../react-core/Enums/Dictionaries/CurrencySymbolDictionary";
import { UnRealisedGainLossColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/UnRealisedGainLossColumns";
import { UnRealisedGainLossDetailModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/UnRealisedGainLossDetailModel";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { ITableConfig, Table } from "../../../../../../../Shared/Table/Table";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { Contents } from "../../Insights/Resource/Contents";
import { StarTooltip } from "../Resource/Contents";

interface IUnrealisedGainLossTableProps {
    data: UnRealisedGainLossDetailModel[];
}
export const getUnRealisedCol = (currencyCode: string): ITableConfig[] => {
    return [
        {
            title: (
                <span>
                    Code
                    <AriaTooltip cssWrapper="is-info-icon ml-5">{StarTooltip}</AriaTooltip>
                </span>
            ),
            filterTitle: "Code",
            key: "DisplayName",
            tableFilter: UnRealisedGainLossColumns.Code,
            filterOption: { disableEdit: true },
        },
        {
            title: "Qty",
            key: "Quantity",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            tableFilter: UnRealisedGainLossColumns.Qty,
            filterOption: { disableEdit: true },
        },
        {
            title: "Cost",
            key: "Cost",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            tableFilter: UnRealisedGainLossColumns.Cost,
        },
        {
            title: `Cost ${currencyCode}`,
            key: "CostInBaseCurrency",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                return data.Amount.toFixed(4);
            },
            tableFilter: UnRealisedGainLossColumns.CostGBP,
            filterOption: { disableEdit: true },
        },
        {
            title: "Price",
            key: "Price",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            tableFilter: UnRealisedGainLossColumns.Price,
        },
        {
            title: `Price ${currencyCode}`,
            key: "PriceInBaseCurrency",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                return data.Amount.toFixed(4);
            },
            tableFilter: UnRealisedGainLossColumns.PriceGBP,
            filterOption: { disableEdit: true },
        },
        {
            title: `Unrealised gain/loss ${currencyCode}`,
            key: "UnRealisedGainLossInBaseCurrency",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                return data.Amount.toFixed(4);
            },
            tableFilter: UnRealisedGainLossColumns.UnRealisedGBP,
            filterOption: { disableEdit: true },
        },
    ];
};
export const UnrealisedGainLossTable = (props: IUnrealisedGainLossTableProps) => {
    if (!props.data) {return null;}
    if (props.data.length == 0) {return <Alert alertType={AlertType.Warning} message={Contents.noDataErrorMessage} />;}

    const [currentPage, setCurrentPage] = React.useState(1);
    const [tableData, setTableData] = React.useState(props.data.slice(0, 49));
    const currencyCode = CurrencySymbolDictionary.getStringMap(props.data[0].CostInBaseCurrency.Currency);
    return (
        <Table
            data={tableData}
            colEditorKey={"UnRealisedGainLossColumnSettings"}
            col={getUnRealisedCol(currencyCode)}
            TotalBody={[
                { data: "Total", colIndex: 0 },
                {
                    data: props.data
                        .reduce((sum, ele) => sum + ele.UnRealisedGainLossInBaseCurrency.Amount, 0)
                        .toFixed(4),
                    colIndex: 6,
                    tfTdCssWrapper: "cell-right",
                },
            ]}
            needPagination={{
                pageSize: 50,
                isShowPerPageOptions: true,
                totalNumOfResult: props.data.length,
                onPaginationChange: (pageIndex, pageSize) => {
                    const max = pageIndex * pageSize - 1;
                    const min = pageSize * (pageIndex - 1);
                    setCurrentPage(pageIndex);
                    setTableData(props.data.slice(min, max));
                },
                currentPage: currentPage,
            }}
        />
    );
};
